import {Component, OnInit} from '@angular/core';
import {BaseModalComponent, CommonSharedModule} from "common-shared";
import {AceConfigInterface} from "ngx-ace-wrapper";
import 'brace';
import 'brace/mode/html';
import 'brace/theme/xcode';

@Component({
  selector: 'app-html-editor-modal',
  templateUrl: './html-editor-modal.component.html',
  styles: ``
})
export class HtmlEditorModalComponent extends BaseModalComponent implements OnInit {
  title: string;
  htmlContent: any;
  entityId: string;

  public config: AceConfigInterface = {
    mode: 'html',
    theme: 'xcode',
    readOnly: false,
    showLineNumbers: false,
    showGutter: false,
    showPrintMargin: false,
    cursorStyle: 'wide',
    enableBasicAutocompletion: true,
    fontSize: 15,
    highlightActiveLine: false,
    highlightSelectedWord: false,
    wrap: true,
    maxLines: Infinity,
  };

  ngOnInit(): void {

  }
}
